// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copy-data-when-hover-link-color-b5818{color:var(--color-brand-6)}.copy-data-when-hover-paragraph-41391{line-height:24px;max-width:200px;min-height:24px;word-break:break-all}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link-color": "copy-data-when-hover-link-color-b5818",
	"linkColor": "copy-data-when-hover-link-color-b5818",
	"paragraph": "copy-data-when-hover-paragraph-41391"
};
export default ___CSS_LOADER_EXPORT___;
